import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";

class HabitualTardinessReport extends Component {

    renderThresholds(month) {
        const thresholds = [];

        if (month.exceedsLateInstances) {
            thresholds.push("4+ lates");
        }

        if (month.exceedsLateMinutes) {
            thresholds.push("60+ minutes");
        }

        return thresholds.join(", ");
    }

    renderLateDates(month) {
        return month.lateDates.map((lateDate) => {
            return moment(lateDate.date, 'YYYY-MM-DD').format('MMM DD') + " (" + lateDate.minutes + ")";
        }).join(", ");
    }

    renderRows() {
        const { reportData } = this.props;

        return reportData.reduce((rows, employeeData) => {
            const { months } = employeeData;

            months.forEach((month, index) => {
                rows.push(
                    <tr key={employeeData.employee._id + "-" + month.month}>
                        {index === 0 &&
                            <td rowSpan={months.length}>
                                {getFullName(employeeData.employee)}
                                <div className="text-muted">
                                    {employeeData.employee.employeeNumber}
                                </div>
                            </td>
                        }
                        <td>{month.label}</td>
                        <td>{month.lateInstances}</td>
                        <td>{month.totalMinutes}</td>
                        <td>{this.renderThresholds(month)}</td>
                        <td>{this.renderLateDates(month)}</td>
                    </tr>
                );
            });

            return rows;
        }, []);
    }

    render() {

        const { reportData, year } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="Habitual Tardiness Report"
                  category={year + " - months with 4 lates or more or 60 late minutes or more"}
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table
                      hover
                      responsive
                      striped
                    >
                      <thead>
                        <tr>
                          <th>Names</th>
                          <th>Month</th>
                          <th>Lates</th>
                          <th>Minutes</th>
                          <th>Threshold reached</th>
                          <th>Late dates (minutes)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData && reportData.length > 0
                          ? this.renderRows()
                          : (
                            <tr>
                              <td colSpan='6'>No results found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default HabitualTardinessReport;
